export default __webpack_public_path__ + "static/media/fa-light-300.49f690d9.woff";